// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import EditIcon from '@mui/icons-material/Edit';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import AirlineStopsIcon from '@mui/icons-material/AirlineStops';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import TextsmsIcon from '@mui/icons-material/Textsms';


// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";
import { useEffect, useState } from "react";

import moment from "moment";

import FilterDialog from "./components/filterPopup";
import StatusDialog from "./components/statusPopup";
import InvoiceDialog from "./components/invoicesPopup";
import HistoryDialog from "./components/HistoryPopup";
import { getPackages, deletePackage, getCountries } from "network/service";
import { useNavigate } from "react-router-dom";
import FilterAltIcon from '@mui/icons-material/FilterAlt';

import * as XLSX from 'xlsx';
import { Delete } from "@mui/icons-material";
import DeleteDialog from "./components/deletePopup";
import SMSDialog from "./components/SmsPopup";
import VendorBooking from "./components/VendorBooking";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Tooltip from '@mui/material/Tooltip';


let status_titles = {
    0: "Pending",
    5: "Picked Up",
    1: "Intransit",
    2: "On Hold",
    3: "Delivered",
    4: "Issue"
}

let dashboardTableHeader = [
    { Header: "Date & Time", accessor: "time" },
    { Header: "Capex awb no", accessor: "tracking_number_internal" },
    { Header: "Customer name", accessor: "cname" },
    { Header: "Receiver name", accessor: "rname" },
    { Header: "Country", accessor: "tocountry" },
    { Header: "Branch", accessor: "bName" },
    { Header: "Carrier", accessor: "carrier" },
    { Header: "AWB", accessor: "awb" },
    { Header: "Vendor AWB", accessor: "vawb" },
    { Header: "Weight", accessor: "weight" },
    { Header: "No. Boxes", accessor: "boxes" },
    { Header: "Status", accessor: "status" },
    { Header: "", accessor: "wx" },
];

function Packages() {

    const initialFilters = JSON.parse(localStorage.getItem('filters')) || {
        from: new Date(),
        to: new Date(),
        status: [],
    };

    const navigate = useNavigate();
    const [countries, setCountries] = useState([]);
    const [loading, setLoading] = useState(false);
    const [dElems, setDelems] = useState([]);
    const [popup, setPopup] = useState({ open: false, details: null });
    const [statuspopup, setStatusPopup] = useState({ open: false, details: null });
    const [invoicepopup, setInvoicePopup] = useState({ open: false, details: null });
    const [historypopup, setHistoryPopup] = useState({ open: false, details: null });
    const [deletepopup, setDeletePopup] = useState({ open: false, details: null });
    const [smspopup, setSmsPopup] = useState({ open: false, details: null });
    const [vendorpopup, setVendorPopup] = useState({ open: false, details: null });
    const [data, setData] = useState([]);






    const [filters, setFilters] = useState(initialFilters);

    const editPackage = (id) => {
        navigate('/new', { state: { id: id } });
    }

    // Opens the New form prefilled from this shipment; nothing is saved until Create.
    const duplicatePackage = (id) => {
        navigate('/new', { state: { duplicateFrom: id } });
    }

    const exportToExcel = (filename, details) => {
        const ws = XLSX.utils.json_to_sheet(details);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
        XLSX.writeFile(wb, `${filename}.xlsx`);
    };

    const Popup = ({ message, handleDelete }) => {
        return (
            <div className="popup">
                <div className="popup-inner">
                    <p>{message}</p>
                    <button onClick={handleDelete}>Yes</button>
                    <button onClick={() => window.location.reload()}>No</button>
                </div>
            </div>
        );
    };

    function matchCountry(id) {
        for (var i = 0; i < countries.length; i++) {
            if (countries[i]._id == id) {
                return countries[i].name;
            }
        }
    };

    async function formDashboardTableRow(arr) {
        let result;
        result = [];
        console.log(arr)


        for (const ele of arr) {
            const temp = {
                time: new Date(ele.createdAt).toLocaleString(),

                tracking_number_internal: (
                    <a href={`https://capexcourier.com/track/?tracking=${ele.tracking_number_internal}`} target="_blank" rel="noopener noreferrer">{ele.tracking_number_internal}</a>
                ),
                cname: ele.from.name,
                rname: ele.to.name,
                tocountry: matchCountry(ele.to.country),
                bName: ele.branch.name,
                carrier: ele.carrier.name,
                awb: ele.tracking_number,
                vawb: ele.vendor_awb || "-",
                weight: ele.total_weight,
                boxes: ele.boxes.length,
                status: `${status_titles[ele.status]}`,
                wx: (
                    <MDBox color="text">
                        <RemoveRedEyeIcon sx={{ fontWeight: "bold", margin: 1 }} fontSize="small"
                            onClick={() => {
                                console.log("Historic Tracking");
                                setHistoryPopup({ open: true, details: ele });
                            }} />
                        <FileDownloadIcon sx={{ fontWeight: "bold", margin: 1 }} fontSize="small"
                            onClick={() => {
                                console.log("Downloading Invoices");
                                setInvoicePopup({ open: true, details: ele });
                            }} />
                        <AirlineStopsIcon sx={{ fontWeight: "bold", margin: 1 }} fontSize="small"
                            onClick={() => {
                                console.log("Opening the status change dialog");
                                setStatusPopup({ open: true, details: ele });
                            }} />
                        <EditIcon sx={{ fontWeight: "bold", margin: 1 }} fontSize="small"
                            onClick={() => {
                                editPackage(ele._id);
                            }} />
                        <Tooltip title="Duplicate shipment">
                            <ContentCopyIcon sx={{ fontWeight: "bold", margin: 1, cursor: "pointer" }} fontSize="small"
                                onClick={() => {
                                    duplicatePackage(ele._id);
                                }} />
                        </Tooltip>
                        <Delete sx={{ fontWeight: "bold", margin: 1 }} fontSize="small"
                            onClick={() => {
                                console.log("delete");
                                setDeletePopup({ open: true, details: ele });
                            }} />
                        <TextsmsIcon sx={{ fontWeight: "bold", margin: 1 }} fontSize="small"
                            onClick={() => {
                                console.log("sms");
                                setSmsPopup({ open: true, details: ele });
                            }} />
                        <LocalShippingIcon
                            sx={{ fontWeight: "bold", margin: 1, color: ele.vendor_awb ? "green" : "inherit" }}
                            fontSize="small"
                            onClick={() => {
                                console.log("vendor booking");
                                setVendorPopup({ open: true, details: ele });
                            }} />
                    </MDBox>
                ),
            };
            result.push(temp);
        }
        setDelems(result.reverse());
    }

    const getValues = (filter) => {
        setLoading(true);
        setFilters(filter);
        console.log(filter);
        let query_param = `createdAt_gte=${moment(filter.from).format("YYYY-MM-DD")}&createdAt_lte=${moment(filter.to).add("day", 1).format("YYYY-MM-DD")}`;
        if (filter.status.length > 0) {
            query_param += `&status_in=${filter.status.join('&status_in=')}`;
        }
        console.log(query_param);
        getPackages(query_param)
            .then((resp) => {
                setData(resp.data);
                setLoading(false);
                formDashboardTableRow(resp.data)
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    }

    useEffect(() => {
        getCountries().then((resp) => {
            console.log(resp.data, "shahid");
            setCountries(resp.data);
        }).catch((err) => {
            console.log(err);
        })
    }, [setCountries]);

    useEffect(() => {
        getValues({ ...filters });
    }, [setFilters, setDelems, setLoading]);

    useEffect(() => {
        localStorage.setItem('filters', JSON.stringify(filters));
    }, [filters]);

    return (
        <DashboardLayout>
            <DashboardNavbar />

            <MDBox pt={6} pb={3}>
                {statuspopup.open && <StatusDialog isopen={statuspopup.open} apply={(detail) => { setStatusPopup({ open: false, details: null }) }} details={statuspopup.details} handleclose={() => { setStatusPopup({ open: false, details: null }) }} />}
                {deletepopup.open && <DeleteDialog isopen={deletepopup.open} apply={(detail) => { setDeletePopup({ open: false, details: null }) }} details={deletepopup.details} handleclose={() => { setDeletePopup({ open: false, details: null }) }} />}
                {historypopup.open && <HistoryDialog isopen={historypopup.open} apply={(detail) => { setHistoryPopup({ open: false, details: null }) }} details={historypopup.details} handleclose={() => { setHistoryPopup({ open: false, details: null }) }} />}
                {invoicepopup.open && <InvoiceDialog isopen={invoicepopup.open} apply={(detail) => { setInvoicePopup({ open: false, details: null }) }} details={invoicepopup.details} handleclose={() => { setInvoicePopup({ open: false, details: null }) }} />}
                {popup.open && <FilterDialog isopen={popup.open} apply={(detail) => { getValues(detail); setPopup({ open: false, details: null }) }} details={popup.details} handleclose={() => { setPopup({ open: false, details: null }) }} />}
                {smspopup.open && <SMSDialog isopen={smspopup.open} apply={(detail) => { setSmsPopup({ open: false, details: null }) }} details={smspopup.details} handleclose={() => { setSmsPopup({ open: false, details: null }) }} />}
                {vendorpopup.open && <VendorBooking isopen={vendorpopup.open} details={vendorpopup.details} handlesuccess={() => { getValues({ ...filters }); }} handleclose={() => { setVendorPopup({ open: false, details: null }) }} />}
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Packages Table
                                </MDTypography>
                            </MDBox>
                            <MDBox
                                mx={2}
                                mt={0}
                                py={2}
                                px={0}
                                borderRadius="lg"
                                alignSelf="flex-end"
                            >
                                <MDButton variant="gradient" color="info" style={{ margin: 5 }}
                                    onClick={() => {
                                        setPopup({ open: true, details: { ...filters } });
                                    }}>
                                    <FilterAltIcon fontSize="medium" ></FilterAltIcon>
                                    &nbsp;Filter
                                </MDButton>
                                <MDButton variant="gradient" color="info" style={{ margin: 5 }}
                                    onClick={async () => {
                                        console.log("Exporting the available data");
                                        let export_data = [];
                                        for (let dt of data) {
                                            export_data.push({
                                                id: dt.code, sender: dt.from.name,
                                                sender_address: `${dt.from.address}, ${dt.from.address2 ? dt.from.address2 : ""}, ${dt.from.address3 ? dt.from.address3 : ""}, ${dt.from.city ? dt.from.city : ""}, ${dt.from.state ? dt.from.state : ""}, ${dt.from.pincode ? dt.from.pincode : ""}`,
                                                receiver: dt.to.name,
                                                receiver_address: `${dt.to.address}, ${dt.to.address2 ? dt.to.address2 : ""}, ${dt.to.address3 ? dt.to.address3 : ""}, ${dt.to.city ? dt.to.city : ""}, ${dt.to.state ? dt.to.state : ""}, ${dt.to.pincode ? dt.to.pincode : ""}`,
                                                status: status_titles[dt.status],
                                                boxes: dt.boxes ? dt.boxes.length : 0,
                                                awb: dt.tracking_number ? dt.tracking_number : '',
                                                branch: dt.branch ? dt.branch.name : "",
                                                weight: dt.total_weight ? dt.total_weight : "",
                                                courier_amount: dt.courier_amount ? dt.courier_amount : "",
                                                other_amount: dt.other_amount ? dt.other_amount : ""
                                            });
                                        }
                                        exportToExcel("Export_" + moment().unix().toString(), export_data);
                                    }}>
                                    <Icon sx={{ fontWeight: "bold" }}>download</Icon>
                                    &nbsp;Export
                                </MDButton>
                            </MDBox>
                            <MDBox pt={0}>
                                <DataTable
                                    table={{ columns: dashboardTableHeader, rows: dElems }}
                                    canSearch
                                />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default Packages;
